import React from 'react'
import styled from 'styled-components'
import breakpoints from '../../styles/breakpoints'
import colors from '../../styles/colors'
import fonts from '../../styles/fonts'

const Sticker = styled.div`
  ${fonts.openSans};
  position: absolute;
  bottom: 10px;
  z-index: 1;
  font-size: 8px;
  padding: 4px 0;
  border-top: 1px solid ${colors.lightGreen};
  border-bottom: 1px solid ${colors.lightGreen};
  color: ${colors.lightGreen};
  width: calc(100% - 20px);
  left: 10px;
  text-align: center;

  @media (max-width: 350px) {
    font-size: 7px;
  }

  @media (min-width: ${breakpoints.xl}) {
    font-size: 12px;
    padding: 16px 0;
    width: calc(100% - 44px);
    left: 22px;
    bottom: 30px;
  }
`

const MessageSticker = ({children}) => {
  return (
    <Sticker>
      {children}
    </Sticker>
  )
}

export default MessageSticker
